/**
 * Lazy loader for the agent-cursor chunk (cursor.js) — the forms-loader
 * pattern: the import URL is computed at runtime from the widget
 * script's own directory so esbuild leaves the `import()` native.
 */
import type { hideAgentCursor, showAgentCursor } from './agent-cursor';

export type CursorModule = {
  showAgentCursor: typeof showAgentCursor;
  hideAgentCursor: typeof hideAgentCursor;
};

let chunkBase: string | null = null;
let cached: Promise<CursorModule> | null = null;
let loaded: CursorModule | null = null;

/** Set once at boot from the app.js directory (same base as the other chunks). */
export function setCursorChunkBase(base: string): void {
  chunkBase = base.replace(/\/$/, '');
}

/** The module if it has already arrived — lets a clear skip the import. */
export function cursorIfLoaded(): CursorModule | null {
  return loaded;
}

export function loadCursor(): Promise<CursorModule> {
  if (!cached) {
    if (!chunkBase) {
      return Promise.reject(new Error('[showpilot] cursor chunk base not configured'));
    }
    const url = `${chunkBase}/cursor.js`;
    cached = import(/* @vite-ignore */ url)
      .then((m: Partial<CursorModule>) => {
        if (typeof m.showAgentCursor !== 'function' || typeof m.hideAgentCursor !== 'function') {
          throw new Error('[showpilot] cursor chunk loaded but module shape is wrong');
        }
        loaded = m as CursorModule;
        return loaded;
      })
      .catch((err: unknown) => {
        cached = null;
        throw err;
      });
  }
  return cached;
}

export function resetCursorLoaderForTests(): void {
  chunkBase = null;
  cached = null;
  loaded = null;
}
